<div tabindex="0" class="player-container h-100-p w-100-p">
  <div
    #playerName
    id="playerNameId"
    class="player-name"
    (click)="onVideoSelected()"
  >
    <div class="name-area id-area">
      <div class="id-area-number">{{ playerId >= 1000 ? 1 : playerId }}</div>
    </div>
    <span class="name-area camera-area" *ngIf="sensor != null">{{ sensor.name + " | " + streamName }}</span>
    <div class="name-area status-area">
      <mat-icon>play_circle_outline</mat-icon>
    </div>
  </div>

  <div
    #playerContent
    id="playerContentId"
    class="player-content w-100-p h-100-p"
  >
    <img *ngIf="sensor == null" style="width: 20%;" [src]="noVideoSvg">
    <div
      *ngIf="sensor"
      class="w-100-p h-100-p"
      style="display: flex; justify-content: center; align-items: center;"
    >
      <video-player-selector [sensor]="sensor" style="width: 100%;"></video-player-selector>


    </div>
    <div *ngIf="videoErrorMessage" class="error-message">
      <h2>
        {{ "ICMS._PLAY_VIDEO_ERROR" | transloco }}
      </h2>
      <p>
        {{ videoErrorMessage | transloco }}
      </p>
      <button mat-raised-button (click)="videoErrorMessage = null">
        {{ "ICMS._CLOSE" | transloco }}
      </button>
    </div>

    <!-- add to do this trick because i couldn't figure out how to give blockUI a different id for every video-player -->
    <div *ngIf="videoLoading" class="w-100-p h-100-p video-loading">
      <div
        *blockUI="'block-section-video-loading'"
        class="w-100-p h-100-p"
      ></div>
    </div>
  </div>
</div>
